import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=19e1463c&scoped=true&lang=pug"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=19e1463c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e1463c",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.components.social_events.empty_state?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fevents%2FEmptyState.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.components.social_events.empty_state?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fevents%2FEmptyState.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)

export default component.exports